import store from '@/store'
import { toMiliseconds } from '@/utils/promise-util'
import isElectron from 'is-electron'

const eventsForIdle = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart']
let idleTimer
// [DEBUG IDLE] Ticker e deadline para expor a contagem regressiva na UI.
let countdownInterval
let idleDeadline = 0

function updateCountdown() {
  const remainingMs = Math.max(0, idleDeadline - Date.now())
  const seconds = Math.ceil(remainingMs / 1000)
  store.commit('app/idle/SET_COUNTDOWN_SECONDS', seconds)
}

function startCountdownTicker() {
  clearInterval(countdownInterval)
  updateCountdown()
  countdownInterval = setInterval(updateCountdown, 1000)
}

function resetIdleTimer() {
  clearTimeout(idleTimer)
  const time = store.state.app?.idle?.idleState?.idleTime || toMiliseconds({ min: 1 })

  if (store.state.app?.idle?.idleState?.isIdle)
    store.dispatch('app/idle/setIsIdle', { isIdle: false })

  // [DEBUG IDLE] Reinicia a contagem regressiva visível no header do ATM.
  idleDeadline = Date.now() + time
  startCountdownTicker()

  idleTimer = setTimeout(() => {
    // reiniciar idle se houver overlay ativo em tela
    if (store.state.app?.loadingOverlay?.show) {
      resetIdleTimer()
      return
    }

    if (!store.state.app?.idle?.idleState?.isIdle)
      store.dispatch('app/idle/setIsIdle', { isIdle: true })
  }, time)
}

const getInitialState = () => ({
  idleState: {
    isEnabled: false,
    isIdle: false,
    idleTime: toMiliseconds({ min: 1 }),
    bannerTime: toMiliseconds({ sec: 10 }),
    // [DEBUG IDLE] Segundos restantes até disparar o idle (exibido no header).
    countdownSeconds: 0,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    isIdle(state) {
      return state.idleState.isIdle
    },
    // [DEBUG IDLE] Getters temporários para diagnóstico no header do ATM.
    countdownSeconds(state) {
      return state.idleState.countdownSeconds
    },
    isIdleEnabled(state) {
      return state.idleState.isEnabled
    },
  },

  mutations: {
    SET_IS_IDLE_ENABLED(state, isEnabled) {
      state.idleState.isEnabled = isEnabled
    },
    SET_IS_IDLE(state, isIdle) {
      state.idleState.isIdle = isIdle
    },
    // [DEBUG IDLE] Atualiza a contagem regressiva exibida na UI.
    SET_COUNTDOWN_SECONDS(state, seconds) {
      state.idleState.countdownSeconds = seconds
    },

    CLEAN_STATE(state) {
      const defaultData = getInitialState()
      Object.keys(defaultData).forEach(key => {
        state[key] = defaultData[key]
      })
    },
  },

  actions: {
    setIsIdle({ commit }, { isIdle }) {
      commit('SET_IS_IDLE', isIdle)
    },

    restartIdle() {
      resetIdleTimer()
    },

    async initIdle({ state, commit }) {
      if (state.idleState.isEnabled) return

      if (!isElectron()) return

      const payBoxData = await window.electronAPI.system.identifyPayboxRead()

      if (!payBoxData?.isAtm) return

      commit('SET_IS_IDLE_ENABLED', true)

      eventsForIdle.forEach(event => {
        document.addEventListener(event, resetIdleTimer, true)
      })
      resetIdleTimer()
    },
    destroyIdle({ commit }) {
      commit('SET_IS_IDLE_ENABLED', false)
      eventsForIdle.forEach(event => {
        document.removeEventListener(event, this.resetIdleTimer, true)
      })
      clearTimeout(idleTimer)
      clearInterval(countdownInterval)
    },

    async cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
